// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn::after {
  content: none !important;
  display: none !important;
}

.instrument-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px 16px;
  min-width: min(720px, 80vw);
  padding-top: 8px;
}

.form-error {
  grid-column: 1/-1;
  padding: 12px;
  border-left: 4px solid var(--danger);
  background: color-mix(in srgb, var(--danger) 10%, white);
  color: var(--danger);
}

.type-calibrations {
  border-top: 1px solid #dee2e6;
  display: grid;
  gap: 10px;
  grid-column: 1/-1;
  padding: 12px 0;
}

.type-calibrations h3 {
  font-size: 0.95rem;
  margin: 0;
}

.type-calibrations__item {
  align-items: center;
  display: grid;
  gap: 8px 20px;
  grid-template-columns: minmax(0, 1fr) auto 190px;
}

.type-calibrations__item mat-form-field {
  width: 190px;
}

.vendor-services {
  border-top: 1px solid #dee2e6;
  display: grid;
  gap: 12px;
  grid-column: 1/-1;
  padding: 12px 0;
}

.vendor-services h3 {
  font-size: 0.95rem;
  margin: 0;
}

.vendor-services__row {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(150px, 2fr) repeat(3, minmax(130px, 1fr)) 40px;
}

.vendor-services > button {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  justify-self: start;
}

.instrument-form__actions {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.instrument-form__buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.date-input::-webkit-calendar-picker-indicator {
  display: none;
}

:host ::ng-deep .mat-mdc-form-field {
  --mdc-outlined-text-field-focus-label-text-color: var(--primary);
  --mdc-outlined-text-field-focus-outline-color: var(--primary);
  --mat-select-focused-arrow-color: var(--primary);
}

@media (max-width: 700px) {
  .instrument-form {
    grid-template-columns: 1fr;
    min-width: 0;
  }
  .type-calibrations__item {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .type-calibrations__item mat-form-field {
    grid-column: 1/-1;
    width: 100%;
  }
  .vendor-services__row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-equipment/instrument-form-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,oCAAA;EACA,wDAAA;EACA,oBAAA;AACF;;AAEA;EAAqB,6BAAA;EAA+B,aAAA;EAAe,SAAA;EAAW,iBAAA;EAAqB,eAAA;AAMnG;;AALA;EAAwB,kBAAA;EAAmB,SAAA;AAU3C;;AATA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,aAAA;EAAe,gDAAA;AAgB9E;;AAfA;EAA0C,YAAA;AAmB1C;;AAlBA;EAAmB,6BAAA;EAA+B,aAAA;EAAe,SAAA;EAAW,iBAAA;EAAqB,eAAA;AA0BjG;;AAzBA;EAAsB,kBAAA;EAAmB,SAAA;AA8BzC;;AA7BA;EAAwB,mBAAA;EAAqB,aAAA;EAAe,QAAA;EAAU,4EAAA;AAoCtE;;AAnCA;EAA4B,mBAAA;EAAqB,oBAAA;EAAsB,QAAA;EAAU,mBAAA;AA0CjF;;AAxCA;EAA4B,oBAAA;EAAsB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AA+CzF;;AA9CA;EAA4B,aAAA;EAAe,WAAA;EAAY,yBAAA;AAoDvD;;AAlDA;EAAiD,aAAA;AAsDjD;;AApDA;EACE,gEAAA;EACA,6DAAA;EACA,gDAAA;AAuDF;;AApDA;EACE;IACE,0BAAA;IACA,YAAA;EAuDF;EArDA;IAA2B,0CAAA;EAwD3B;EAvDA;IAA0C,iBAAA;IAAqB,WAAA;EA2D/D;EA1DA;IAAwB,oDAAA;EA6DxB;AACF","sourcesContent":[".btn::after {\n  content: none !important;\n  display: none !important;\n}\n\n.instrument-form {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 4px 16px;\n  min-width: min(720px, 80vw);\n  padding-top: 8px;\n}\n\n.form-error {\n  grid-column: 1 / -1;\n  padding: 12px;\n  border-left: 4px solid var(--danger);\n  background: color-mix(in srgb, var(--danger) 10%, white);\n  color: var(--danger);\n}\n\n.type-calibrations { border-top: 1px solid #dee2e6; display: grid; gap: 10px; grid-column: 1 / -1; padding: 12px 0; }\n.type-calibrations h3 { font-size: .95rem; margin: 0; }\n.type-calibrations__item { align-items: center; display: grid; gap: 8px 20px; grid-template-columns: minmax(0, 1fr) auto 190px; }\n.type-calibrations__item mat-form-field { width: 190px; }\n.vendor-services { border-top: 1px solid #dee2e6; display: grid; gap: 12px; grid-column: 1 / -1; padding: 12px 0; }\n.vendor-services h3 { font-size: .95rem; margin: 0; }\n.vendor-services__row { align-items: center; display: grid; gap: 8px; grid-template-columns: minmax(150px, 2fr) repeat(3, minmax(130px, 1fr)) 40px; }\n.vendor-services > button { align-items: center; display: inline-flex; gap: 6px; justify-self: start; }\n\n.instrument-form__actions { align-items: stretch; display: flex; flex-direction: column; gap: .5rem; }\n.instrument-form__buttons { display: flex; gap: .5rem; justify-content: flex-end; }\n\n.date-input::-webkit-calendar-picker-indicator { display: none; }\n\n:host ::ng-deep .mat-mdc-form-field {\n  --mdc-outlined-text-field-focus-label-text-color: var(--primary);\n  --mdc-outlined-text-field-focus-outline-color: var(--primary);\n  --mat-select-focused-arrow-color: var(--primary);\n}\n\n@media (max-width: 700px) {\n  .instrument-form {\n    grid-template-columns: 1fr;\n    min-width: 0;\n  }\n  .type-calibrations__item { grid-template-columns: minmax(0, 1fr) auto; }\n  .type-calibrations__item mat-form-field { grid-column: 1 / -1; width: 100%; }\n  .vendor-services__row { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
